import {
  GET_CIVILBUDGETMATERIAL,
  GET_CIVILBUDGETMATERIAL_SUCCESS,
  GET_CIVILBUDGETMATERIAL_FAIL,
  DELETE_CIVILBUDGETMATERIAL,
  DELETE_CIVILBUDGETMATERIAL_SUCCESS,
  DELETE_CIVILBUDGETMATERIAL_FAIL,
  UPDATE_CIVILBUDGETMATERIAL,
  UPDATE_CIVILBUDGETMATERIAL_SUCCESS,
  UPDATE_CIVILBUDGETMATERIAL_FAIL,
  ADD_NEW_CIVILBUDGETMATERIAL,
  ADD_CIVILBUDGETMATERIAL_SUCCESS,
  ADD_CIVILBUDGETMATERIAL_FAIL,
  CIVILBUDGETMATERIAL_LOADING,
  CIVILBUDGETMATERIAL_RESET
} from "./actionType";

export const resetCivilBudgetMaterialState = (actionType) => ({
  type: CIVILBUDGETMATERIAL_RESET,
  payload: { actionType },
});

export const getCivilBudgetMaterialSuccess = (actionType, data) => ({
  type: GET_CIVILBUDGETMATERIAL_SUCCESS,
  payload: { actionType, data },
});

export const getCivilBudgetMaterialFail = (actionType, error) => ({
  type: GET_CIVILBUDGETMATERIAL_FAIL,
  payload: { actionType, error },
});

export const getCivilBudgetMaterial = data => ({
  type: GET_CIVILBUDGETMATERIAL,
  payload: data,
});

export const getCivilBudgetMaterialLoading = () => ({
  type: CIVILBUDGETMATERIAL_LOADING
});

export const deleteCivilBudgetMaterial = data => ({
  type: DELETE_CIVILBUDGETMATERIAL,
  payload: data,
});

export const deleteCivilBudgetMaterialSuccess = data => ({
  type: DELETE_CIVILBUDGETMATERIAL_SUCCESS,
  payload: data,
});

export const deleteCivilBudgetMaterialFail = error => ({
  type: DELETE_CIVILBUDGETMATERIAL_FAIL,
  payload: error,
});

export const updateCivilBudgetMaterial = data => ({
  type: UPDATE_CIVILBUDGETMATERIAL,
  payload: data,
});

export const updateCivilBudgetMaterialFail = error => ({
  type: UPDATE_CIVILBUDGETMATERIAL_FAIL,
  payload: error,
});

export const updateCivilBudgetMaterialSuccess = data => ({
  type: UPDATE_CIVILBUDGETMATERIAL_SUCCESS,
  payload: data,
});

export const addNewCivilBudgetMaterial = data => ({
  type: ADD_NEW_CIVILBUDGETMATERIAL,
  payload: data,
});

export const addCivilBudgetMaterialSuccess = data => ({
  type: ADD_CIVILBUDGETMATERIAL_SUCCESS,
  payload: data,
});

export const addCivilBudgetMaterialFail = error => ({
  type: ADD_CIVILBUDGETMATERIAL_FAIL,
  payload: error,
});